<script lang="ts">
    import SearchBar from '$saga/views/Search/SearchBar.svelte';
    import { OptionList } from '$saga/types/search.types';

    export let defaultSportOptions: OptionList = [];
    export let defaultDestinationOptions: OptionList = [];
    export let defaultDurationMin: number;
    export let defaultDurationMax: number;
    export let defaultBudgetMin: number;
    export let defaultBudgetMax: number;
    export let defaultLevels: OptionList = [];
    export let defaultTags: OptionList = [];
    export let defaultTypes: OptionList = [];
    export let searchForm: never;
</script>

<SearchBar
    {defaultDestinationOptions}
    {defaultSportOptions}
    {defaultBudgetMax}
    {defaultBudgetMin}
    {defaultDurationMax}
    {defaultDurationMin}
    {defaultLevels}
    {defaultTags}
    {defaultTypes}
    {searchForm}
/>
